import { writable } from "svelte/store";
import { service } from "./services";
import type { ApiResultOfListOfGame, Game } from "./walletapi";
import { RegisterStartupCallback } from "./startup";


export const games = writable<Game[]>([]);


//let firstStartup = true;
export async function GamesListStartup(firstStartup: boolean)
{
    RefreshGames();

    if (!firstStartup) return;
    //firstStartup = false;

    service.walletapi.registerOperation("GameChanged", "GameChanged", GameChanged);
    service.walletapi.registerOperation("GameAdded", "GameAdded", GameAdded);
}

RegisterStartupCallback("GamesListStartup", GamesListStartup);

export async function RefreshGames() {
    try {
        let response: ApiResultOfListOfGame = await service.walletapi.gamesList({
            Token: sessionStorage.token,
        });

        if (response.Success && response.Data) {
            games.set(response.Data); 
        } else {
            console.error('Error al obtener la lista de administradores:', response.ErrorMessage);
        }
    } catch (error) {
        console.error('Error en la llamada a la API:', error);
    }
}

export function GameChanged(game: Game)
{   
    console.log("GameChanged", game);

    games.update(list => {
        let gameIndex = list.findIndex(p => p.Id == game.Id);
        if (gameIndex == -1)
        {
            // no such player
            return list;
        }
        
        list[gameIndex] = game;

        return list;
    });
};

export function GameAdded(game: Game)
{   
    console.log("GameAdded", game);

    games.update(list => {
        list.unshift(game);
        return list;
    });
};
